import type React from 'react';

import Button, { type ButtonProps } from '@mui/material/Button';
import Grid, { type GridProps } from '@mui/material/Grid';
import classnames from 'classnames';

import { BodyRegularBold } from 'components/typography/Typography';

import { useStyles } from './styles';

const ToolsGrid: React.FC<React.PropsWithChildren<GridProps>> = (props) => {
  const { classes } = useStyles();

  return <Grid {...props} className={classnames(props.className, classes.ToolsGrid)} />;
};

export const ToolButton: React.FC<React.PropsWithChildren<ButtonProps>> = (props) => {
  const { classes } = useStyles();
  return (
    <Grid item>
      <Button {...props} className={classnames(props.className, classes.ToolButton)} />
    </Grid>
  );
};

export const ToolText: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const { classes } = useStyles();
  return (
    <Grid item className={classes.ToolText}>
      <BodyRegularBold>{children}</BodyRegularBold>
    </Grid>
  );
};

export default ToolsGrid;
